import { useEffect, useState, useRef } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [hovering, setHovering] = useState(false);
  const [label, setLabel] = useState("");

  useEffect(() => {
    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let rx = mx, ry = my;
    let raf;

    const onMove = (e) => {
      mx = e.clientX; my = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
      }
    };
    const loop = () => {
      rx += (mx - rx) * 0.15;
      ry += (my - ry) * 0.15;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(loop);
    };
    loop();

    const onOver = (e) => {
      const t = e.target.closest("[data-cursor]");
      if (t) {
        setHovering(true);
        setLabel(t.getAttribute("data-cursor") || "");
      } else if (e.target.closest("a, button, [data-magnetic]")) {
        setHovering(true);
        setLabel("");
      }
    };
    const onOut = (e) => {
      if (!e.relatedTarget || (!e.relatedTarget.closest && true)) { setHovering(false); setLabel(""); return; }
      if (!e.relatedTarget.closest("a, button, [data-magnetic], [data-cursor]")) {
        setHovering(false); setLabel("");
      }
    };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);
    return () => {
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div
        ref={dotRef}
        className="cursor-dot pointer-events-none fixed top-0 left-0 z-[9999] hidden md:block"
        style={{
          width: hovering ? 0 : 6,
          height: hovering ? 0 : 6,
          background: "#fff",
          borderRadius: 9999,
          mixBlendMode: "difference",
          transition: "width .2s, height .2s",
        }}
        data-testid="custom-cursor-dot"
      />
      <div
        ref={ringRef}
        className="cursor-ring pointer-events-none fixed top-0 left-0 z-[9999] hidden md:flex items-center justify-center"
        style={{
          width: hovering ? (label ? 92 : 56) : 28,
          height: hovering ? (label ? 92 : 56) : 28,
          border: hovering ? "1px solid #F42B29" : "1px solid #fff",
          background: hovering ? "#F42B29" : "transparent",
          color: "#fff",
          borderRadius: 9999,
          transition: "width .35s cubic-bezier(.22,1,.36,1), height .35s cubic-bezier(.22,1,.36,1), background .3s",
          mixBlendMode: hovering ? "normal" : "difference",
        }}
        data-testid="custom-cursor-ring"
      >
        {label && (
          <span className="font-display uppercase text-[10px] tracking-[0.18em] text-white">{label}</span>
        )}
      </div>
    </>
  );
}
